import { FC, LabelHTMLAttributes } from "react";
import { Radio } from "shared/components/Spor";
import styled from "styled-components";

const Label = styled.label`
  color: ${({ theme }) => theme.colorTextMain};
  font-family: VYSans, sans-serif;
  font-size: 1rem;
  line-height: 1.33rem;
  display: inline-flex;
  align-items: center;
  vertical-align: top;
  gap: 6px;
  cursor: pointer;
`;

interface RadioButtonProps extends LabelHTMLAttributes<HTMLLabelElement> {
  value: string;
}

export const RadioButton: FC<RadioButtonProps> = ({
  value,
  children,
  ...props
}) => (
  <Label {...props}>
    <Radio value={value} />
    {children}
  </Label>
);
